// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const QuoteLinkBold: React.FC = () => {
    return (
        <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4919_14865)">
                <path
                    d="M8.25 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9.75"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 1.40918C14.578 1.40918 14.1734 1.5768 13.875 1.87517L6.75 9.00017L6 12.0002L9 11.2502L16.125 4.12517C16.4234 3.8268 16.591 3.42213 16.591 3.00017C16.591 2.57821 16.4234 2.17354 16.125 1.87517C15.8266 1.5768 15.422 1.40918 15 1.40918Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4919_14865">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const QuoteLinkBoldOffset: IconOffset = {
    vertical: 12,
    horizontal: 18,
};

export default React.memo(QuoteLinkBold);
